module.exports = __webpack_public_path__ + "static/img/img-nav3.115150f7.png";